import { Button } from '@/components/ui/button';
import { Message } from '@/components/ui/message';
import React from 'react';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const ResetPasswordMessage = ({ onClick }: Props) => {
  return (
    <Message>
      Forgot your password?{' '}
      <Button variant="link" size="link" className="underline text-foreground" onClick={onClick}>
        Click here
      </Button>{' '}
      to reset your password.
    </Message>
  );
};

export default ResetPasswordMessage;
